import startsWith from 'lodash/startsWith';

import { TeamNanoID } from '../../../../teams/teamsTypes';
import { PrimaryNavTabTooltipItem } from '../../../../../app/components/menus/PrimaryNav/helpers/PrimaryNavTooltipMenuTab/PrimaryNavTooltipMenuTab.types';

import { TeamsPermissions } from '../../../../teams/teamsConstants';
import { TeamPath } from '../../../../teams/TeamPath';

import { words } from '../../../../../locales/keys';

const enum AiStudioSecondaryMenuItems {
  AI_STUDIO = 'ai-studio',
  EDIT_AI_STUDIO = 'edit-ai-studio'
}

export const companyAiStudioMenuLinks = (
  companyNanoId: TeamNanoID,
  isSelf: boolean
): PrimaryNavTabTooltipItem[] => [
  {
    name: AiStudioSecondaryMenuItems.AI_STUDIO,
    href: TeamPath.companyAiStudio(companyNanoId),
    i18nText: words.show,
    activeTest: (pathname: string) =>
      startsWith(pathname, TeamPath.companyAiStudio(companyNanoId)),
    permissions: isSelf
      ? [TeamsPermissions.READ_SELF_COMPANY_EDIT_AI_STUDIO_PAGE]
      : [TeamsPermissions.READ_OTHER_COMPANY_EDIT_AI_STUDIO_PAGE]
  },
  {
    name: AiStudioSecondaryMenuItems.EDIT_AI_STUDIO,
    href: TeamPath.companyEditAiStudio(companyNanoId),
    i18nText: words.edit,
    permissions: isSelf
      ? [TeamsPermissions.READ_SELF_COMPANY_EDIT_AI_STUDIO_PAGE]
      : [TeamsPermissions.READ_OTHER_COMPANY_EDIT_AI_STUDIO_PAGE]
  }
];
